/* eslint-disable react-hooks/exhaustive-deps */
import useFetch from '@hooks/useFetch';

/**
 *
 * @param { String } username - Username of the profile to be fetched
 * @param { Object } options
 * @param {Function | null | undefined} options.selector - Selects a value from the profile data
 * @param {Object | null | undefined} options.fallbackData - Data to fallback on
 * @param {String | null | undefined} options.goalUid - Goal based profile for educator levels
 * @returns {Object | SelectedValue}
 */
const useCalendarInfo = (
  goalUID,
  time,
  dateKey,
  options = { fallbackData: undefined }
) => {
  const key = null;

  const { data: calendarInfo, ...rest } = useFetch(
    key,
    {},
    { fallbackData: options.fallbackData }
  );

  return {
    key,
    calendarData: { [dateKey]: calendarInfo },
    ...rest
  };
};

export default useCalendarInfo;
